<template>
    <BaseModal :title="'Branding'" @close="closeModal">
        <template #modalContent>
            <div class="modal-content-wrapper">
                <div class="modal-content">
                    <div class="modal-heading">
                        <h3>Room Branding</h3>
                    </div>
                    <div>
                        <div class="logo-img">
                            <img :src="roomLogoUrl" @click="handleLogoUpload" />
                        </div>
                        <label class="custm-clr-label mt-1">/* Click to upload your logo */</label>
                    </div>
                    <div class="input-banner-btn mt-8" @click="triggerFileInput">
                        <div class="button-text">
                            <p for="fileInput" v-if="!isBannerSelected" class="text-one">
                                /* <br>Click to upload or drag and drop your brand cover image <br>*/
                            </p>
                            <p v-if="!isBannerSelected" class="text-two">
                                jpg, jpeg, png, or gif (recommended size 1440px by 600px)
                            </p>
                        </div>
                        <input type="file" id="fileInput" @change="handleBannerUpload" accept="image/*"
                            style="display: none" ref="fileInput" />
                        <div v-if="isBannerSelected" style="position: relative; display: inline-block;">
                            <img :src="roomBannerUrl" alt="Uploaded Image" style="cursor: pointer; display: block;" />
                            <button @click.stop="removeBanner" style="position: absolute;
                                top: -10px;
                                right: -10px;
                                width: 24px;
                                height: 24px;
                                border-radius: 50%;
                                background: red;
                                color: white;
                                font-size: 16px;
                                font-weight: bold;
                                border: none;
                                cursor: pointer;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);">
                                x
                            </button>
                        </div>
                    </div>
                    <div class="choose-color mt-8">
                        <label class="text">brand.color</label>
                        <RoomColorPicker class="mt-2" :roomDetails="roomDetails" />
                    </div>
                    <vs-button v-if="isSavingChanges" class="mt-8" type="border" >>>saving...</vs-button>
                    <vs-button v-else class="mt-8" type="border" @click="handleUpdateBranding">>>save</vs-button>
                </div>
                <div class="cast-modal-bottom">
                    <p>>> Estimated time to setup > <span>5mins - 7mins</span></p>
                </div>
            </div>
        </template>
    </BaseModal>
</template>

<script>
import api from "../../../../../http/api/api.js";
import BaseModal from "@/components/common/BaseModal.vue";
import RoomColorPicker from '@/views/new-dashboard/rooms/components/RoomColorPicker.vue';
import constants from '@/../constant.js';

export default {
    name: 'RoomBranding',
    props: ['closeModal', 'roomDetails', 'getRoomList'],
    components: {
        BaseModal,
        RoomColorPicker,
    },
    data() {
        return {
            roomLogoUrl: this.roomDetails.logo,
            roomBannerUrl: '',
            roomLogoUri: this.roomDetails.logo,
            roomBannerUri: '',
            isBannerSelected: false,
            isSavingChanges: false,
        };
    },
    mounted() {
        var img;
        if (this.roomDetails.cover_image !== '') {
            this.roomBannerUrl = this.roomDetails.cover_image;
            this.roomBannerUri = this.roomDetails.cover_image;
            this.isBannerSelected = true;
        }
        if (this.roomDetails.logo === '') {
            img = require('@/assets/images/logot.svg');
            this.roomLogoUrl = img;
            this.roomLogoUri = img;
        } else {
            img = URL.createObjectURL(this.roomDetails.logo);
            this.roomLogoUrl = img;
            this.roomLogoUri = img;
        }
    },
    methods: {
        handleBannerUpload(event) {
            const file = event.target.files[0];
            if (file) {
                // Assuming you are using FileReader to display the uploaded image
                this.isBannerSelected = true;
                this.roomBannerUrl = URL.createObjectURL(event.target.files[0]);
                this.roomBannerUri = file;
            }
        },
        removeBanner() {
            this.isBannerSelected = false;
            this.roomBannerUrl = '';
            this.roomBannerUri = '';
        },
        triggerFileInput() {
            // Trigger the file input click when the image is clicked
            this.$refs.fileInput.click();
        },
        handleLogoUpload() {
            const fileInput = document.createElement('input');
            fileInput.type = 'file';
            fileInput.accept = 'image/*';
            fileInput.onchange = (e) => {
                const file = e.target.files[0];
                if (file) {
                    const reader = new FileReader();
                    reader.onload = (event) => {
                        this.roomLogoUrl = URL.createObjectURL(file);
                        this.roomLogoUri = file;
                    };
                    reader.readAsDataURL(file);
                }
            };
            fileInput.click();
        },
        async handleUpdateBranding() {
            const apiUrl = `${constants.apiRoomUrl}/api/update/room/details/`;

            const formData = new FormData();
            formData.append("room_id", this.roomDetails.room_id);
            formData.append("cover_image", this.roomBannerUri);
            formData.append("logo", this.roomLogoUri);
            formData.append("primary_color", this.roomDetails.primary_color);
            this.isSavingChanges = true;
            try {
                const response = await api.patch(
                    apiUrl,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                        },
                    }
                );
                this.getRoomList();
                this.$vs.notify({
                    title: 'Changes Saved!',
                    text: "Your room's branding details have been successfully updated.",
                    color: 'success',
                });
                this.isSavingChanges = false;
                this.closeModal();
            } catch (error) {
                this.isSavingChanges = false;
                console.error("Error updating room details");
            }
        },
    }
}
</script>

<style scoped>
.logo-img {
    border: 1px dashed #FFFFFF;
    height: 90px;
    width: 90px;
    margin-top: 1rem;
    margin-bottom: 0.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.logo-img img {
    height: 90px;
    width: 90px;
    object-fit: contain;
}

.custm-clr-label {
    color: #64748B;
    font-size: 12px;
}

.input-banner-btn {
    border: 1px dashed #FFFFFF;
    height: 140px;
    width: 350px;
    cursor: pointer;
}

.input-banner-btn img {
    height: 140px;
    width: 350px;
    object-fit: contain;
}

.text-one {
    color: #5B96EB;
    font-size: 12px;
    padding: 0.5rem 1.2rem 0rem 1.2rem;
}

.text-two {
    color: #64748B;
    font-size: 12px;
    padding: 0 1.2rem 0.5rem 1.2rem;
}
</style>